const quizContent1_1 = {
  category: "Amerika",
  question: "In welcher Stadt steht die Freiheitsstatue?",
  answerA: "Boston",
  answerB: "New York City",
  answerC: "Chicago",
  answerD: "Miami",
  points: 10,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent1_2 = {
  category: "Amerika",
  question: "Welche Farben hat die US-Flagge?",
  answerA: "Blau, Gelb, Rot",
  answerB: "Rot, Weiß, Blau",
  answerC: "Grün, Weiß, Rot",
  answerD: "Schwarz, Weiß, Rot",
  points: 20,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent1_3 = {
  category: "Amerika",
  question: "Welches Tier ist das Nationalsymbol der USA?",
  answerA: "Grizzlybär",
  answerB: "Weißkopfseeadler",
  answerC: "Bison",
  answerD: "Puma",
  points: 30,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent1_4 = {
  category: "Amerika",
  question: "Welcher Fluss ist der längste der USA?",
  answerA: "Colorado River",
  answerB: "Ohio River",
  answerC: "Missouri River",
  answerD: "Mississippi River",
  points: 40,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent1_5 = {
  category: "Amerika",
  question:
    "In welchem Jahr wurde die Unabhängigkeitserklärung der USA unterzeichnet?",
  answerA: "1776",
  answerB: "1783",
  answerC: "1791",
  answerD: "1804",
  points: 50,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent1_6 = {
  category: "Japan",
  question: "Welcher Berg ist der höchste in Japan?",
  answerA: "Norikura",
  answerB: "Fuji",
  answerC: "Tate",
  answerD: "Haku",
  points: 10,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent1_7 = {
  category: "Japan",
  question: "Welche Währung wird in Japan verwendet?",
  answerA: "Yuan",
  answerB: "Won",
  answerC: "Yen",
  answerD: "Ringgit",
  points: 20,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent1_8 = {
  category: "Japan",
  question:
    "Wie nennt man die japanische Kampfsportart, die „sanfter Weg“ bedeutet?",
  answerA: "Karate",
  answerB: "Kendo",
  answerC: "Aikido",
  answerD: "Judo",
  points: 30,
  correctAnswer: "answerD",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent1_9 = {
  category: "Japan",
  question: "Wie nennt man die japanische Kunst des Papierfaltens?",
  answerA: "Kintsugi",
  answerB: "Origami",
  answerC: "Kirigami",
  answerD: "Kamon",
  points: 40,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent1_10 = {
  category: "Japan",
  question:
    "Wie lautet das japanische Wort für einen wandernden, herrenlosen Samurai?",
  answerA: "Sensei",
  answerB: "Daimyō",
  answerC: "Ronin",
  answerD: "Shogun",
  points: 50,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent1_11 = {
  category: "TV-Serien",
  question: "Welche Serie spielt auf dem fiktiven Kontinent Westeros?",
  answerA: "The Witcher",
  answerB: "Game of Thrones",
  answerC: "The Last Kingdom",
  answerD: "Vikings",
  points: 10,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent1_12 = {
  category: "TV-Serien",
  question:
    "In „Breaking Bad“, wie heißt der Freund und Partner von Walter White?",
  answerA: "Gus Fring",
  answerB: "Jessie Pinkman",
  answerC: "Saul Goodman",
  answerD: "Hank Schrader",
  points: 20,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent1_13 = {
  category: "TV-Serien",
  question:
    "Wie heißt der Bruder von Michael Scofield, der zu Beginn der Serie inhaftiert ist?",
  answerA: "Lincoln Burrows",
  answerB: "Paul Kellerman",
  answerC: "Terrence Steadman",
  answerD: "James Scofield",
  points: 30,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent1_14 = {
  category: "TV-Serien",
  question: "In „Peaky Blinders“, wie heißt der Clanführer der Shelby-Familie?",
  answerA: "John Shelby",
  answerB: "Arthur Shelby",
  answerC: "Tommy Shelby",
  answerD: "Michael Gray",
  points: 40,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent1_15 = {
  category: "TV-Serien",
  question:
    "In „Loki“, wie heißt die Organisation, die Zeitkriminalität überwacht?",
  answerA: "TVA",
  answerB: "HYDRA",
  answerC: "SHIELD",
  answerD: "SWORD",
  points: 50,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent1_16 = {
  category: "Römer",
  question: "Wer war der erste Kaiser von Rom?",
  answerA: "Julius Caesar",
  answerB: "Augustus",
  answerC: "Nero",
  answerD: "Trajan",
  points: 10,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent1_17 = {
  category: "Römer",
  question: "Was war das Forum Romanum?",
  answerA: "Ein römisches Theater",
  answerB: "Ein Marktplatz und politisches Zentrum",
  answerC: "Eine Gladiatorenarena",
  answerD: "Eine römische Bibliothek",
  points: 20,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent1_18 = {
  category: "Römer",
  question:
    "Welches berühmte Bauwerk wurde von Kaiser Vespasian in Rom erbaut?",
  answerA: "Das Kolosseum",
  answerB: "Der Circus Maximus",
  answerC: "Der Pantheon",
  answerD: "Das Forum Romanum",
  points: 30,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent1_19 = {
  category: "Römer",
  question: "Wie hieß die römische Göttin der Weisheit und des Krieges?",
  answerA: "Venus",
  answerB: "Mars",
  answerC: "Minerva",
  answerD: "Juno",
  points: 40,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent1_20 = {
  category: "Römer",
  question:
    "Wie hieß der berühmte römische Architekt, der unter Augustus das Pantheon baute?",
  answerA: "Vitruvius",
  answerB: "Apollodorus von Damaskus",
  answerC: "Marcus Agrippa",
  answerD: "Pliny der Jüngere",
  points: 50,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent1_21 = {
  category: "Bekannte Personen",
  question: "Wer gründete Microsoft?",
  answerA: "Bill Gates",
  answerB: "Steve Jobs",
  answerC: "Ronald Wayne",
  answerD: "Satya Nadella",
  points: 10,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent1_22 = {
  category: "Bekannte Personen",
  question: "Wie heißt der bekannte Mitbegründer von Apple neben Steve Jobs?",
  answerA: "Jeff Bezos",
  answerB: "Paul Allen",
  answerC: "Bill Gates",
  answerD: "Steve Wozniak",
  points: 20,
  correctAnswer: "answerD",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent1_23 = {
  category: "Bekannte Personen",
  question: "Wer ist bekannt als das Orakel von Omaha?",
  answerA: "Jerome H. Powell",
  answerB: "Ray Dalio",
  answerC: "Warren Buffet",
  answerD: "Carl Icahn",
  points: 30,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent1_24 = {
  category: "Bekannte Personen",
  question: "Wer entdeckte Radium und gewann zwei Nobelpreise?",
  answerA: "Isaac Newton",
  answerB: "Albert Einstein",
  answerC: "Marie Curie",
  answerD: "Stephen Hawking",
  points: 40,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent1_25 = {
  category: "Bekannte Personen",
  question:
    "Wer spielt die Hauptrolle in dem Film „From the World of John Wick: Ballerina“?",
  answerA: "Jodie Foster",
  answerB: "Camila Cabello",
  answerC: "Margot Robbie",
  answerD: "Ana de Armas",
  points: 50,
  correctAnswer: "answerD",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent2_1 = {
  category: "Philosophie",
  question: "Von welchem Philosoph stammt das Werk „Die Republik“?",
  answerA: "Aristoteles",
  answerB: "Nietzsche",
  answerC: "Platon",
  answerD: "Mark Twain",
  points: 10,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent2_2 = {
  category: "Philosophie",
  question: "Was ist die Ethik?",
  answerA: "Moralisch richtigen Handelns",
  answerB: "Die Glaubwürdigkeit des Redners",
  answerC: "Antike Heilmethoden",
  answerD: "Das gleiche wie Esoterik",
  points: 20,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent2_3 = {
  category: "Philosophie",
  question: "Von welchem Philosophen stammt das stoische Werk „Meditations“?",
  answerA: "Sokrates",
  answerB: "Epictetus",
  answerC: "Seneca",
  answerD: "Marcus Aurelius",
  points: 30,
  correctAnswer: "answerD",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent2_4 = {
  category: "Philosophie",
  question: "Was ist der Solipsismus?",
  answerA: "Das Konzept das nur man selbst sicher existiert",
  answerB: "Wenn man seine Einsamkeit genießt",
  answerC: "Wenn man alleine etwas durchsteht",
  answerD: "Das Konzept das man durch Einsamkeit neue Ideen hat",
  points: 40,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent2_5 = {
  category: "Philosophie",
  question: "Was bedeutet „Cogito, ergo sum“?",
  answerA: "Kognitive Fähigkeiten zählen",
  answerB: "Ich denke, also bin ich",
  answerC: "Ich denke, es ist eine Summe",
  answerD: "Kognitive Fähigkeiten, werden siegen",
  points: 50,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent2_6 = {
  category: "Informatik",
  question: "Welches Programm braucht man um auf eine Website gehen zu können?",
  answerA: "Distributor",
  answerB: "Office 365",
  answerC: "Word",
  answerD: "Browser",
  points: 10,
  correctAnswer: "answerD",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent2_7 = {
  category: "Informatik",
  question: "Welches Datenkabel hat die höchste Übertragungsleistung?",
  answerA: "Audiokabel",
  answerB: "Koaxialkabel",
  answerC: "Glasfaser",
  answerD: "HDMI Kabel",
  points: 20,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent2_8 = {
  category: "Informatik",
  question: "Was ist das „Moor’sche Gesetz“?",
  answerA:
    "Prozessoren verdoppeln etwa alle 18–24 Monate ihre Leistungsfähigkeit",
  answerB: "Prozessoren verbrauchen mit der Zeit weniger Strom",
  answerC: "Prozessoren werden nur größer, nicht schneller",
  answerD: "Prozessoren bekommen alle vier Jahre neue Transistoren",
  points: 30,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent2_9 = {
  category: "Informatik",
  question: "Warum wurde JavaScript so genannt wie es heißt?",
  answerA: "Aus Marketinggründen",
  answerB: "Weil es vom gleichen Macher ist wie Java",
  answerC: "Weil dem Entwickler die Idee dazu auf der Insel Java kam",
  answerD: "Weil es so ähnlich zu Java ist",
  points: 40,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent2_10 = {
  category: "Informatik",
  question:
    "Wenn man einen Downloadspeed von 50Mbit/s hat und eine 100MB Datei runterlädt, wie lange dauert das?",
  answerA: "16 Sekunden",
  answerB: "2 Sekunden",
  answerC: "1 Sekunden",
  answerD: "4 Sekunden",
  points: 50,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent2_11 = {
  category: "Skurriles",
  question: "Welches Tier kann beim Schlafen „stehen bleiben“ ohne Umzufallen?",
  answerA: "Ameisenbär",
  answerB: "Faultiere",
  answerC: "Elefanten",
  answerD: "Koalas",
  points: 10,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent2_12 = {
  category: "Skurriles",
  question:
    "Der Mitbegründer von welchem Unternehmen hat sein Hühnchen „zwangskanibalisiert“?",
  answerA: "Amazon",
  answerB: "Enron",
  answerC: "Meta",
  answerD: "Netflix",
  points: 20,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent2_13 = {
  category: "Skurriles",
  question: "Welches Tier heißt „Firefox“?",
  answerA: "Ein roter Fuchs",
  answerB: "Ein roter Armeisenbär",
  answerC: "Ein roter Panda",
  answerD: "Ein rotes Faultier",
  points: 30,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent2_14 = {
  category: "Skurriles",
  question: "Welche Essens-Kuriosität ist tatsächlich wahr?",
  answerA: "Kartoffeln wurden früher als Dessert gegessen",
  answerB: "Karotten waren ursprünglich lila",
  answerC: "Tomaten gab es zuerst in blau",
  answerD: "Brokkoli ist ein Wildgemüse",
  points: 40,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent2_15 = {
  category: "Skurriles",
  question: "Welches Land hat offiziell einen Trident auf seiner Flagge?",
  answerA: "Andorra",
  answerB: "Nepal",
  answerC: "Barbados",
  answerD: "Laos",
  points: 50,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent2_16 = {
  category: "Geschichte",
  question: "Wie viele Jahre liegen zwischen dem ersten und zweiten Weltkrieg?",
  answerA: "21",
  answerB: "23",
  answerC: "31",
  answerD: "33",
  points: 10,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent2_17 = {
  category: "Geschichte",
  question:
    "Was waren die ersten nicht von Pferden angetriebenen Fahrzeuge oder Wagen?",
  answerA: "Elektro Fahrzeuge",
  answerB: "Verbrennungsmotor Fahrzeuge",
  answerC: "Dampfwagen",
  answerD: "Der Schlitten vom Weihnachtsmann",
  points: 20,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent2_18 = {
  category: "Geschichte",
  question: "Wo wurde die Demokratie erfunden?",
  answerA: "In Babylon",
  answerB: "In Washington DC",
  answerC: "In Neapel",
  answerD: "In Athen",
  points: 30,
  correctAnswer: "answerD",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent2_19 = {
  category: "Geschichte",
  question: "Wer umsegelte als erster Mensch die Erde?",
  answerA: "Ferdinand Magellan",
  answerB: "Christoph Kolumbus",
  answerC: "Nikolaus Kopernikus",
  answerD: "James Cook",
  points: 40,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent2_20 = {
  category: "Geschichte",
  question: "Wo kämpften die 300 Spartaner gegen die Perser?",
  answerA: "Mykene",
  answerB: "Korinth",
  answerC: "Thermopylen",
  answerD: "Delphi",
  points: 50,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent2_21 = {
  category: "Zitate",
  question:
    "Von wem stammt folgendes Zitat: „Sei ängstlich, wenn die anderen gierig sind, und gierig, wenn die anderen ängstlich sind.“?",
  answerA: "Rothschild",
  answerB: "Warren Buffet",
  answerC: "Jesse Livermore",
  answerD: "André Kostolany",
  points: 10,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent2_22 = {
  category: "Zitate",
  question:
    "Von wem stammt folgendes Zitat: „Das Ganze ist mehr als die Summe seiner Teile“?",
  answerA: "Sokrates",
  answerB: "Aristoteles",
  answerC: "Mark Twain",
  answerD: "Platon",
  points: 20,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent2_23 = {
  category: "Zitate",
  question: "Von wem stammt folgendes Zitat: „Wollt ihr den totalen Krieg“?",
  answerA: "Adolf Hitler",
  answerB: "Bernd Ernst",
  answerC: "Joseph Goebbels",
  answerD: "Theodor Morell",
  points: 30,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent2_24 = {
  category: "Zitate",
  question:
    "Von wem stammt folgendes Zitat: „Sei du selbst die Veränderung, die du dir wünschst für diese Welt.“?",
  answerA: "Mahatma Gandhi",
  answerB: "Martin Luther King",
  answerC: "Nelson Mandela",
  answerD: "Galileo Galilei",
  points: 40,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent2_25 = {
  category: "Zitate",
  question:
    "Von wem stammt folgendes Zitat: „Ich habe nie einen Plan B gehabt. Plan A ist der einzige Weg.“?",
  answerA: "Angelina Jolie",
  answerB: "Keanu Reeves",
  answerC: "Will Smith",
  answerD: "Henry Ford",
  points: 50,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent3_1 = {
  category: "Afrika",
  question: "In welchem Land liegt die Stadt Kapstadt?",
  answerA: "Namibia",
  answerB: "Südafrika",
  answerC: "Botswana",
  answerD: "Mosambik",
  points: 10,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent3_2 = {
  category: "Afrika",
  question: "Welcher Ozean liegt östlich von Afrika?",
  answerA: "Atlantik",
  answerB: "Indischer Ozean",
  answerC: "Pazifik",
  answerD: "Arktischer Ozean",
  points: 20,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent3_3 = {
  category: "Afrika",
  question:
    "Welche afrikanische Insel liegt östlich vom Kontinent im Indischen Ozean?",
  answerA: "Madagaskar",
  answerB: "Sansibar",
  answerC: "Kap Verde",
  answerD: "Komoren",
  points: 30,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent3_4 = {
  category: "Afrika",
  question: "Wie heißt die größte Stadt Marokkos?",
  answerA: "Marrakesch",
  answerB: "Rabat",
  answerC: "Fes",
  answerD: "Casablanca",
  points: 40,
  correctAnswer: "answerD",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent3_5 = {
  category: "Afrika",
  question:
    "Welches afrikanische Land war früher unter dem Namen „Zaire“ bekannt?",
  answerA: "Angola",
  answerB: "Kongo Brazzaville",
  answerC: "Demokratische Republik Kongo",
  answerD: "Gabun",
  points: 50,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent3_6 = {
  category: "Gesundheit",
  question:
    "Wieviel Wasser sollte ein Erwachsener durchschnittlich pro Tag trinken?",
  answerA: "0,5 Liter",
  answerB: "1 Liter",
  answerC: "1,5-2 Liter",
  answerD: "4 Liter",
  points: 10,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent3_7 = {
  category: "Gesundheit",
  question:
    "Welcher Sinn ist hauptsächlich für das Gleichgewicht verantwortlich?",
  answerA: "Sehen",
  answerB: "Riechen",
  answerC: "Innenohr",
  answerD: "Haut",
  points: 20,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent3_8 = {
  category: "Gesundheit",
  question: "Welcher Stoff sorgt im Blut für den Sauerstofftransport?",
  answerA: "Hämoglobin",
  answerB: "Insulin",
  answerC: "Adrenalin",
  answerD: "Melatonin",
  points: 30,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent3_9 = {
  category: "Gesundheit",
  question: "Welche Art von Fett gilt als „gesund“ für das Herz?",
  answerA: "Gesättigte Fettsäuren",
  answerB: "Ungesättigte Fettsäuren",
  answerC: "Transfette",
  answerD: "Tierische Fette",
  points: 40,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent3_10 = {
  category: "Gesundheit",
  question: "Wie nennt man den medizinischen Fachbegriff für Bluthochdruck?",
  answerA: "Hypertonie",
  answerB: "Hypotonie",
  answerC: "Tachykardie",
  answerD: "Bradykardie",
  points: 50,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent3_11 = {
  category: "Filme",
  question: "Wer spielte die Hauptrolle in Titanic?",
  answerA: "Brad Pitt",
  answerB: "Leonardo DiCaprio",
  answerC: "Tom Cruise",
  answerD: "Johnny Depp",
  points: 10,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent3_12 = {
  category: "Filme",
  question: "Wie heißt der Clown-Fisch Vater in Findet Nemo?",
  answerA: "Dory",
  answerB: "Marlin",
  answerC: "Bruce",
  answerD: "Crush",
  points: 20,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent3_13 = {
  category: "Filme",
  question:
    "In welchem Film spielt Tom Hanks einen Mann, der auf einer einsamen Insel strandet?",
  answerA: "Cast Away",
  answerB: "Forrest Gump",
  answerC: "Captain Philips",
  answerD: "Sully",
  points: 30,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent3_14 = {
  category: "Filme",
  question: "Wer führte Regie bei Pulp Fiction?",
  answerA: "Quentin Tarantino",
  answerB: "Martin Scorsese",
  answerC: "Guy Ritchie",
  answerD: "Francis Ford Coppola",
  points: 40,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent3_15 = {
  category: "Filme",
  question: "Welcher dieser Filme stammt nicht von Christopher Nolan?",
  answerA: "Interstellar",
  answerB: "Tenet",
  answerC: "Inception",
  answerD: "Shutter Island",
  points: 50,
  correctAnswer: "answerD",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent3_16 = {
  category: "Geschichte",
  question: "In welchem Jahr fiel die Berliner Mauer?",
  answerA: "1987",
  answerB: "1988",
  answerC: "1989",
  answerD: "1990",
  points: 10,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent3_17 = {
  category: "Geschichte",
  question:
    "Welches Symbol wurde von den Römern als Zahlzeichen für 10 verwendet?",
  answerA: "V",
  answerB: "X",
  answerC: "L",
  answerD: "C",
  points: 20,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent3_18 = {
  category: "Geschichte",
  question:
    "Welches Ereignis markiert den Beginn der Französischen Revolution?",
  answerA: "Hinrichtung Ludwigs XVI",
  answerB: "Erklärung der Menschenrechte",
  answerC: "Napoleon wird Kaiser",
  answerD: "Erstürmung der Bastille 1789",
  points: 30,
  correctAnswer: "answerD",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent3_19 = {
  category: "Geschichte",
  question: "Wie hieß das deutsche Kaiserreich von 1871 bis 1918 offiziell?",
  answerA: "Weimarer Reich",
  answerB: "Heiliges Deutsches Reich",
  answerC: "Deutsches Kaiserreich",
  answerD: "Großdeutsches Reich",
  points: 40,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent3_20 = {
  category: "Geschichte",
  question: "Wo fand 1815 die berühmte Niederlage Napoleons statt?",
  answerA: "Leipzig",
  answerB: "Waterloo",
  answerC: "Austerlitz",
  answerD: "Toulon",
  points: 50,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent3_21 = {
  category: "Mittelalter",
  question: "Welcher Beruf war im Mittelalter typisch in Städten?",
  answerA: "Schmied",
  answerB: "Astronaut",
  answerC: "Programmierer",
  answerD: "Pilot",
  points: 10,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent3_22 = {
  category: "Mittelalter",
  question: "In welcher Epoche lag das europäische Mittelalter ungefähr?",
  answerA: "50–300",
  answerB: "500–1500",
  answerC: "1600–1800",
  answerD: "1800–2000",
  points: 20,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent3_23 = {
  category: "Mittelalter",
  question: "Wie nannte man die nichtfreien Bauern im Mittelalter?",
  answerA: "Knechte",
  answerB: "Sklaven",
  answerC: "Leibeigene",
  answerD: "Patrizier",
  points: 30,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent3_24 = {
  category: "Mittelalter",
  question: "Wer leitete ein mittelalterliches Kloster?",
  answerA: "Bürgermeister",
  answerB: "Abt/Äbtissin",
  answerC: "König",
  answerD: "Hauptmann",
  points: 40,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent3_25 = {
  category: "Mittelalter",
  question:
    "Welche mittelalterliche Universität gilt als eine der ältesten Europas?",
  answerA: "Harvard",
  answerB: "Salamanca",
  answerC: "Oxford",
  answerD: "Bologna",
  points: 50,
  correctAnswer: "answerD",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent4_1 = {
  category: "Mythologie",
  question: "Wer ist der oberste Gott der griechischen Mythologie?",
  answerA: "Apollo",
  answerB: "Zeus",
  answerC: "Poseidon",
  answerD: "Hades",
  points: 10,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent4_2 = {
  category: "Mythologie",
  question: "Welche Kreatur ist halb Mensch, halb Stier?",
  answerA: "Zentaur",
  answerB: "Satyr",
  answerC: "Minotaurus",
  answerD: "Chimära",
  points: 20,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent4_3 = {
  category: "Mythologie",
  question:
    "Welcher ägyptische Gott hat einen Falkenkopf und ist der Gott des Himmels?",
  answerA: "Anubis",
  answerB: "Horus",
  answerC: "Thot",
  answerD: "Ra",
  points: 30,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent4_4 = {
  category: "Mythologie",
  question: "Welche nordische Kreatur ist die Midgardschlange?",
  answerA: "Ymir",
  answerB: "Jörmungandr",
  answerC: "Nidhögg",
  answerD: "Skoll",
  points: 40,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent4_5 = {
  category: "Mythologie",
  question:
    "Welcher indische Gott wird als der „Zerstörer“ des Universums verehrt?",
  answerA: "Shiva",
  answerB: "Vishnu",
  answerC: "Ganesh",
  answerD: "Brahma",
  points: 50,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent4_6 = {
  category: "Geographie",
  question: "Wie heißt der längste Fluss der Welt?",
  answerA: "Amazonas",
  answerB: "Nil",
  answerC: "Mississippi",
  answerD: "Yangtee",
  points: 10,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent4_7 = {
  category: "Geographie",
  question: "Welches Land ist sowohl in Europa als auch in Asien?",
  answerA: "Israel",
  answerB: "Griechenland",
  answerC: "Türkei",
  answerD: "Ägypten",
  points: 20,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent4_8 = {
  category: "Geographie",
  question: "Welche Hauptstadt hat die meisten Inseln?",
  answerA: "Stockholm",
  answerB: "Helsinki",
  answerC: "Oslo",
  answerD: "Venedig",
  points: 30,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent4_9 = {
  category: "Geographie",
  question: "Welches Land hat die meisten Nationalparks der Welt?",
  answerA: "USA",
  answerB: "Kanada",
  answerC: "Australien",
  answerD: "Brasilien",
  points: 40,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent4_10 = {
  category: "Geographie",
  question: "Wie viele Länder gehören zum Balkan?",
  answerA: "10",
  answerB: "12",
  answerC: "15",
  answerD: "8",
  points: 50,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent4_11 = {
  category: "Fremdwörter",
  question: "Was bedeutet das Wort „dekadent“?",
  answerA: "angemessen",
  answerB: "verschwenderisch",
  answerC: "intelligent",
  answerD: "unterwürfig",
  points: 10,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent4_12 = {
  category: "Fremdwörter",
  question: "Was bedeutet das Wort „adäquat“?",
  answerA: "angemessen",
  answerB: "übertrieben",
  answerC: "vertraut",
  answerD: "flüssig",
  points: 20,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent4_13 = {
  category: "Fremdwörter",
  question: "Was bedeutet das Wort „redundant“?",
  answerA: "fest",
  answerB: "flüssig",
  answerC: "überflüssig",
  answerD: "verändert",
  points: 30,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent4_14 = {
  category: "Fremdwörter",
  question: "Was bedeutet das Wort „kohärent“?",
  answerA: "unterschiedlich",
  answerB: "verschiedene",
  answerC: "auseinander",
  answerD: "zusammenhängend",
  points: 40,
  correctAnswer: "answerD",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent4_15 = {
  category: "Fremdwörter",
  question: "Was bedeutet das Wort „eloquent“?",
  answerA: "ordentlich",
  answerB: "redegewandt",
  answerC: "intelligent",
  answerD: "bescheiden",
  points: 50,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent4_16 = {
  category: "Technik",
  question: "Welche der folgenden Technologien ermöglicht drahtloses Internet?",
  answerA: "Bluetooth",
  answerB: "Wi-Fi",
  answerC: "USB",
  answerD: "Ethernet",
  points: 10,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent4_17 = {
  category: "Technik",
  question: "Was bedeutet HD bei Fernsehgeräten und Monitoren?",
  answerA: "High Density",
  answerB: "High Definition",
  answerC: "High Drive",
  answerD: "High Demand",
  points: 20,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent4_18 = {
  category: "Technik",
  question: "Was ist die Cloud?",
  answerA: "Ein Gerät zur Speicherung von Daten",
  answerB: "Eine Wettervorschau",
  answerC: "Ein Online-Speicherplatz für Daten",
  answerD: "Ein Speichermedium für Computer",
  points: 30,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent4_19 = {
  category: "Technik",
  question: "Was bezeichnet der Begriff Firewall?",
  answerA: "Ein Schutzmechanismus für Computernetzwerke",
  answerB: "Eine spezielle Art von Hardware",
  answerC: "Ein Internetbrowser",
  answerD: "Ein Betriebssystem für Smartphones",
  points: 40,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent4_20 = {
  category: "Technik",
  question: "Was bedeutet der Begriff „VPN“?",
  answerA: "Virtual Private Network",
  answerB: "Variable Personal Network",
  answerC: "Virtual Program Node",
  answerD: "Variable Public Network",
  points: 50,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent4_21 = {
  category: "Sport",
  question:
    "Welcher dieser Sportler ist für seine Leistungen im Fußball bekannt?",
  answerA: "Roger Federer",
  answerB: "Lionel Messi",
  answerC: "Usain Bolt",
  answerD: "Michael Phelps",
  points: 10,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent4_22 = {
  category: "Sport",
  question: "Wie viele Punkte gibt es für ein Touchdown im American Football?",
  answerA: "3",
  answerB: "7",
  answerC: "6",
  answerD: "4",
  points: 20,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent4_23 = {
  category: "Sport",
  question: "Wie viele Runden hat ein Boxkampf normalerweise?",
  answerA: "12",
  answerB: "5",
  answerC: "10",
  answerD: "15",
  points: 30,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent4_24 = {
  category: "Sport",
  question: "In welcher Sportart wird der Ballon d'Or vergeben?",
  answerA: "Basketball",
  answerB: "Tennis",
  answerC: "Fußball",
  answerD: "Handball",
  points: 40,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent4_25 = {
  category: "Sport",
  question:
    "Welcher Fußballverein hat die meisten UEFA Champions League Titel gewonnen?",
  answerA: "Bayern München",
  answerB: "Real Madrid",
  answerC: "Barcelona",
  answerD: "Manchester United",
  points: 50,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent5_1 = {
  category: "Test-Fragen",
  question: "Was ist ein IQ-Test?",
  answerA: "Innerer Quotienten Test",
  answerB: "Ein Test der Vaporizer-Produkte von IQ",
  answerC: "Intelligenz Test (Intelligenz Quotient)",
  answerD: "Der „In Quong-Dynastie-Entstanden“ Test",
  points: 10,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent5_2 = {
  category: "Test-Fragen",
  question:
    "Wie viele Persönlichkeitstypen gibt es laut dem Myers-Briggs-Typenindikator (MBTI)?",
  answerA: "16",
  answerB: "32",
  answerC: "12",
  answerD: "24",
  points: 20,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent5_3 = {
  category: "Test-Fragen",
  question: "Was ist der CAPTCHA Test?",
  answerA: "Ein nettes Bilderrätsel um den Nutzer zu entspannen.",
  answerB: "Ein Intelligenztest.",
  answerC:
    "Ein Test um herauszufinden ob man ein Bewusstsein größer als 1 Φ (Phi) hat.",
  answerD: "Ein Test um herauszufinden ob jemand ein Mensch oder ein Bot ist.",
  points: 30,
  correctAnswer: "answerD",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent5_4 = {
  category: "Test-Fragen",
  question: "Was ist der Turing Test?",
  answerA: "Eine spezielle Art Einstellungstest im IT-Bereich.",
  answerB: "Ein Test um herauszufinden ob eine KI intelligent ist.",
  answerC: "Der erste Fahrtest auf einer neuen Rennstrecke.",
  answerD:
    "Ein sehr moderner Test bei dem die elektrische Spannung inerhalb eines Gases getestet wird.",
  points: 40,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent5_5 = {
  category: "Test-Fragen",
  question: "Was soll die Integrated Information Theory (IIT) messen können?",
  answerA: "Wie schnell die Prozessoren ihre Leistung verdoppeln.",
  answerB: "Wie Bewusst ein System ist gemessen in Φ (Phi).",
  answerC:
    "Wie gut integriert eine Software in dem System ist auf dem sie läuft.",
  answerD: "Wie leistungsstark moderne KI Modelle wie ChatGPT sind.",
  points: 50,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent5_6 = {
  category: "Psychologie",
  question: "Was ist Extraversion bei dem Big Five Modell?",
  answerA: "Wie viel Extra Wurst jemand benötigt.",
  answerB: "Das gibt es nicht.",
  answerC: "Wie hervorragend jemand sich Ausdrücken kann.",
  answerD:
    "Es gibt an wie sehr es jemand nach sozialen Kontakten und gesellschaftlichen Aktivitäten drängt.",
  points: 10,
  correctAnswer: "answerD",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent5_7 = {
  category: "Psychologie",
  question: "Was ist der Behaviorismus?",
  answerA:
    "Eine Theorie, die besagt, dass alle psychischen Prozesse durch die Natur des Gehirns bestimmt werden.",
  answerB:
    "Die psychologische Erforschung und Lehre nach oder anhand des Verhaltens.",
  answerC: "Nur das Verhalten eines Menschen wenn er hungrig ist.",
  answerD:
    "Eine Theorie, die ausschließlich auf der Erforschung von Träumen basiert.",
  points: 20,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent5_8 = {
  category: "Psychologie",
  question: "Wer gilt als Vater der Psychoanalyse?",
  answerA: "John B. Watson",
  answerB: "B. F. Skinner",
  answerC: "Anil Seth",
  answerD: "Sigmund Freud",
  points: 30,
  correctAnswer: "answerD",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent5_9 = {
  category: "Psychologie",
  question: "Wer führte die Experimente am „kleinen Albert“ durch?",
  answerA: "John B. Watson",
  answerB: "B. F. Skinner",
  answerC: "Albert Einstein",
  answerD: "Carl Jung",
  points: 40,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent5_10 = {
  category: "Psychologie",
  question: "Wer ist bekannt für seine Bewusstseinsforschung?",
  answerA: "Sigmund Freud",
  answerB: "Anil Seth",
  answerC: "Ray Dalio",
  answerD: "Carl Jung",
  points: 50,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent5_11 = {
  category: "Schauspieler",
  question: "Wer spielt James Bond in Skyfall?",
  answerA: "Daniel Craig",
  answerB: "Carl Icahn",
  answerC: "Will Smith",
  answerD: "Ed Sheeren",
  points: 10,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent5_12 = {
  category: "Schauspieler",
  question: "Wer spielt den Kopfgeldjäger in Django Unchained?",
  answerA: "Jamie Foxx",
  answerB: "Will Smith",
  answerC: "Christoph Walz",
  answerD: "Gustav Django",
  points: 20,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent5_13 = {
  category: "Schauspieler",
  question: "Wer spielt Hermine in Harry Potter?",
  answerA: "Kaley Cuoco",
  answerB: "Margot Robbie",
  answerC: "Rihanna",
  answerD: "Emma Watson",
  points: 30,
  correctAnswer: "answerD",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent5_14 = {
  category: "Schauspieler",
  question: "Wer spielt Ragnar Lothbrok in der Serie Vikings?",
  answerA: "Christoph Walz",
  answerB: "Travis Fimmel",
  answerC: "Carl Icahn",
  answerD: "Orlando Bloom",
  points: 40,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent5_15 = {
  category: "Schauspieler",
  question: "Wer spielt in „Der Herr der Ringe“ Gandalf?",
  answerA: "Elijah Wood",
  answerB: "J. R. R. Tolkien",
  answerC: "Ian McKellen",
  answerD: "Andy Serkis",
  points: 50,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent5_16 = {
  category: "Songtexte",
  question: "Von welchem Musiker ist der Text „Annie, are you OK?“?",
  answerA: "Tina Turner",
  answerB: "Micheal Jackson",
  answerC: "Madonna",
  answerD: "Elvis",
  points: 10,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent5_17 = {
  category: "Songtexte",
  question:
    "Von welchem Musiker ist der Text „Half of my heart is in Havana, ooh-na-na“?",
  answerA: "Rosalia",
  answerB: "Alvaro Soler",
  answerC: "Shakira",
  answerD: "Camila Cabello",
  points: 20,
  correctAnswer: "answerD",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent5_18 = {
  category: "Songtexte",
  question:
    "Von welcher Band ist der Text „A seven nation army couldn't hold me back“?",
  answerA: "Europe",
  answerB: "The White Stripes",
  answerC: "Nirvana",
  answerD: "Imagine Dragons",
  points: 30,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent5_19 = {
  category: "Songtexte",
  question:
    "Von welchem Musiker ist der Text „I took a pill in Ibiza to show Avicii I was cool“?",
  answerA: "Avicii",
  answerB: "David Guetta",
  answerC: "Mike Posner",
  answerD: "Martin Garrix",
  points: 40,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent5_20 = {
  category: "Songtexte",
  question:
    "Von welchem Musiker ist der Text „Oh, she's hot but a psycho, so left, but she's right, though“?",
  answerA: "Kendrick Lamar",
  answerB: "Post Malone",
  answerC: "Ava Max",
  answerD: "Nicki Minaj",
  points: 50,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent5_21 = {
  category: "Videospiele",
  question:
    "Für was steht die Abkürzung GTA in der gleichnamigen bekannten Spielereihe?",
  answerA: "Grand Theft Auto",
  answerB: "Großer Totaler Absturz",
  answerC: "Grand Trigger Automation",
  answerD: "Großer Terror Anschlag",
  points: 10,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent5_22 = {
  category: "Videospiele",
  question:
    "Welches dieser Spielereihen hat eine dazugehörige und gleichnamige Netflix Serie?",
  answerA: "Metin",
  answerB: "Gothic",
  answerC: "The Witcher",
  answerD: "The Elder Scrolls",
  points: 20,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent5_23 = {
  category: "Videospiele",
  question: "Welches der Stronghold Spiele spielt in der Wüste?",
  answerA: "Legacy",
  answerB: "3",
  answerC: "Legends",
  answerD: "Crusader",
  points: 30,
  correctAnswer: "answerD",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent5_24 = {
  category: "Videospiele",
  question: "Wie heißt Marios Bruder mit Nachnamen bei Super Mario Bros.?",
  answerA: "Mario",
  answerB: "Luigi",
  answerC: "Rossi",
  answerD: "Bianchi",
  points: 40,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent5_25 = {
  category: "Videospiele",
  question: "Welche dieser Rassen gibt es in dem Strategiespiel Starcraft 2?",
  answerA: "Terraner",
  answerB: "Erdlinge",
  answerC: "Minatauren",
  answerD: "Predators",
  points: 50,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent6_1 = {
  category: "Flora & Fauna",
  question: "Welches ist das Nationaltier Australiens?",
  answerA: "Känguru",
  answerB: "Koala",
  answerC: "Wombat",
  answerD: "Emu",
  points: 10,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent6_2 = {
  category: "Flora & Fauna",
  question: "Welches Tier gehört zu den Amphibien?",
  answerA: "Schlange",
  answerB: "Frosch",
  answerC: "Vogel",
  answerD: "Katze",
  points: 20,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent6_3 = {
  category: "Flora & Fauna",
  question: "Welches Tier ist ein Detritusfresser?",
  answerA: "Löwe",
  answerB: "Regenwurm",
  answerC: "Adler",
  answerD: "Hai",
  points: 30,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent6_4 = {
  category: "Flora & Fauna",
  question: "Was ist ein endothermes Tier?",
  answerA: "Kaltblütig",
  answerB: "Gleichwarm",
  answerC: "Pflanzenfresser",
  answerD: "Nachtaktiv",
  points: 40,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent6_5 = {
  category: "Flora & Fauna",
  question:
      "Was ist die Hauptfunktion von Stomata?",
  answerA: "Fortpflanzung",
  answerB: "Gasaustausch",
  answerC: "Wasseraufnahme",
  answerD: "Stabilität",
  points: 50,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent6_6 = {
  category: "Anatomie",
  question: "Wie viele Knochen hat der erwachsene Mensch?",
  answerA: "106",
  answerB: "206",
  answerC: "306",
  answerD: "406",
  points: 10,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent6_7 = {
  category: "Anatomie",
  question: "Wie heißt die Verbindung zwischen zwei Knochen?\n",
  answerA: "Muskel",
  answerB: "Sehne",
  answerC: "Gelenk",
  answerD: "Nerv",
  points: 20,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent6_8 = {
  category: "Anatomie",
  question:
      "Welche Blutkörperchen transportieren Sauerstoff?",
  answerA: "Leukozyten",
  answerB: "Thrombozyten",
  answerC: "Erythrozyten",
  answerD: "Plasma",
  points: 30,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent6_9 = {
  category: "Anatomie",
  question: "Wie heißt der längste Nerv im Körper?",
  answerA: "Vagusnerv",
  answerB: "Ischiasnerv",
  answerC: "Sehnerv",
  answerD: "Fazialisnerv",
  points: 40,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent6_10 = {
  category: "Anatomie",
  question:
      "Welche Funktion hat der Hypothalamus?",
  answerA: "Bewegung",
  answerB: "Hormonregulation",
  answerC: "Verdauung",
  answerD: "Atmung",
  points: 50,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent6_11 = {
  category: "Asien",
  question: "Welches Land ist das größte in Asien?",
  answerA: "Indien",
  answerB: "China",
  answerC: "Russland",
  answerD: "Japan",
  points: 10,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent6_12 = {
  category: "Asien",
  question:
      "Welches Land in Asien hat die größte Bevölkerung?",
  answerA: "Indien",
  answerB: "Indonesien",
  answerC: "China",
  answerD: "Pakistan",
  points: 20,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent6_13 = {
  category: "Asien",
  question:
      "Welche dieser Inseln gehört zu Indonesien?",
  answerA: "Java",
  answerB: "Borneo",
  answerC: "Bali",
  answerD: "Sumatra",
  points: 30,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent6_14 = {
  category: "Asien",
  question: "Welcher asiatische Staat ist der weltweit größte Produzent von Teeblättern?",
  answerA: "China",
  answerB: "Indien",
  answerC: "Sri Lanka",
  answerD: "Japan",
  points: 40,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent6_15 = {
  category: "Asien",
  question:
      "Welches Land hat den weltweit größten muslimischen Bevölkerungsanteil?",
  answerA: "Saudi-Arabien",
  answerB: "Indonesien",
  answerC: "Pakistan",
  answerD: "Iran",
  points: 50,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent6_16 = {
  category: "Geologie",
  question: "Welche Gesteinsart entsteht durch die Abkühlung von Magma?",
  answerA: "Sedimentgestein",
  answerB: "Metamorphes Gestein",
  answerC: "Magmatisches Gestein",
  answerD: "Kalkstein",
  points: 10,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent6_17 = {
  category: "Geologie",
  question: "Was ist der Unterschied zwischen einem Tsunami und einer normalen Welle?",
  answerA: "Tsunamis sind größer und werden durch Wind erzeugt",
  answerB: "Tsunamis entstehen durch Erdbeben oder Unterwasser-Vulkanismus",
  answerC: "Wellen sind immer kleiner als Tsunamis",
  answerD: "Tsunamis entstehen nur im Atlantischen Ozean",
  points: 20,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent6_18 = {
  category: "Geologie",
  question:
      "Was bezeichnet man als „Vulkanismus“?",
  answerA: "Die Ablagerung von Sedimenten",
  answerB: "Der Austritt von Magma an der Erdoberfläche",
  answerC: "Das Aufeinandertreffen von Kontinentalplatten",
  answerD: "Das Entweichen von Gasen aus Gestein",
  points: 30,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent6_19 = {
  category: "Geologie",
  question: "Was ist ein „Seismograph“?",
  answerA: "Ein Gerät zur Messung von Luftdruck",
  answerB: "Ein Instrument zur Bestimmung der Tiefe des Meeresbodens",
  answerC: "Ein Gerät zur Messung von Erdbebenwellen\n",
  answerD: "Ein Gerät zur Bestimmung der Gesteinsdichte",
  points: 40,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent6_20 = {
  category: "Geologie",
  question:
      "Wie heißt das älteste bekannte Gestein auf der Erde?",
  answerA: "Kometenstein",
  answerB: "Zircon",
  answerC: "Granit",
  answerD: "Gneis",
  points: 50,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent6_21 = {
  category: "Abendland",
  question: "Was versteht man unter dem Begriff „Abendland“?",
  answerA: "Europa",
  answerB: "Asien",
  answerC: "Afrika",
  answerD: "Südamerika",
  points: 10,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent6_22 = {
  category: "Abendland",
  question: "Welche große Kathedrale steht in Paris und ist ein Wahrzeichen des Abendlandes?",
  answerA: "Sagrada Familia",
  answerB: "Notre-Dame",
  answerC: "Petersdom",
  answerD: "Kölner Dom",
  points: 20,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent6_23 = {
  category: "Abendland",
  question: "Wer war der erste römische Kaiser?",
  answerA: "Augustus",
  answerB: "Nero",
  answerC: "Julius Caesar",
  answerD: "Trajan",
  points: 30,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent6_24 = {
  category: "Abendland",
  question: "Was war das Hauptziel der Kreuzzüge?",
  answerA: "Der Versuch, das Heilige Land von den Muslimen zurückzuerobern",
  answerB: "Die Ausbreitung des Christentums in Europa",
  answerC: "Die Befreiung von Gefangenen aus der Sklavere",
  answerD: "Der Ausbau des römischen Imperiums",
  points: 40,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent6_25 = {
  category: "Abendland",
  question:
      "Welcher Vertrag beendete den Dreißigjährigen Krieg im Jahr 1648?",
  answerA: "Vertrag von Versailles",
  answerB: "Westfälischer Friede",
  answerC: "Vertrag von Tordesillas",
  answerD: "Vertrag von Utrecht",
  points: 50,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};
const quizContent7_1 = {
  category: "Orient",
  question: "Welches Land gehört zum Orient?",
  answerA: "Italien",
  answerB: "Indien",
  answerC: "Marokko",
  answerD: "Albanien",
  points: 10,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};

const quizContent7_2 = {
  category: "Orient",
  question: "Welches Gewürz ist das berühmteste Gewürz im Orient?",
  answerA: "Kurkuma",
  answerB: "Safran",
  answerC: "Chilli Flocken",
  answerD: "Kümmel",
  points: 20,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};

const quizContent7_3 = {
  category: "Orient",
  question:
      "In welcher Stadt befand sich der historische und geografische Endpunkt der Zugstrecke, des berühmten Orient-Express?",
  answerA: "Ankara",
  answerB: "Bagdad",
  answerC: "Kairo",
  answerD: "Istanbul",
  points: 30,
  correctAnswer: "answerD",
  questionIsActive: false,
  questionFinished: false,
};

const quizContent7_4 = {
  category: "Orient",
  question:
      "Wie wird der asymmetrische Knoten genannt, die an den berühmten Orientteppichen zu sehen sind?",
  answerA: "Tibeter-Knoten",
  answerB: "Ghiordes-Knoten (Türkischer Knoten)",
  answerC: "Senneh-Knoten (Persischer Knoten)",
  answerD: "Orient-Knoten",
  points: 40,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};

const quizContent7_5 = {
  category: "Orient",
  question: "Aus welcher Gewürz-Kombination besteht das Dönergewürz?",
  answerA:
      "Paprikapulver (edelsüß oder rosenscharf), Kreuzkümmel (Cumin), Knoblauch und Oregano",
  answerB: "Pfeffer, Safran, Thymian und Curry",
  answerC: "Salz, getrocknete Tomatenpulver, Muskat und Chilli Flocken",
  answerD: "Zucker, Salz, Zimt und Spekulatius",
  points: 50,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};

const quizContent7_6 = {
  category: "Wirtschaft",
  question: "Welche der folgenden Automarken gehören nicht zum VW-Konzern?",
  answerA: "Porsche",
  answerB: "Skoda",
  answerC: "BMW",
  answerD: "Lamborghini",
  points: 10,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};

const quizContent7_7 = {
  category: "Wirtschaft",
  question: "Was bedeutet die Abkürzung von IKEA?",
  answerA: "Internationales Küchen- und Einrichtungshaus",
  answerB: "Der Name des Gründers + zwei schwedische Städte",
  answerC: "Ingvar Kamprad Elmtaryd Agunnaryd",
  answerD: "Innovative Konzepte Europäischer Arbeiter",
  points: 20,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};

const quizContent7_8 = {
  category: "Wirtschaft",
  question:
      "Welcher Tech-Gigant verlor 1999 als erstes Unternehmen weltweit kurzzeitig seinen Börsenwert an einen Konkurrenten, bevor er wieder an die Spitze zurückkehrte?",
  answerA: "Microsoft",
  answerB: "Apple",
  answerC: "IBM",
  answerD: "Google",
  points: 30,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};

const quizContent7_9 = {
  category: "Wirtschaft",
  question:
      "Was passiert in der Regel mit dem Wert einer Währung auf dem internationalen Markt, wenn die Zentralbank dieses Landes die Zinsen deutlich anhebt?",
  answerA: "Die Währung wertet sich auf",
  answerB: "Die Währung wertet sich ab",
  answerC: "Der Wert bleibt immer exakt gleich",
  answerD: "Die Währung wird automatisch an den Goldstandard gekoppelt",
  points: 40,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};

const quizContent7_10 = {
  category: "Wirtschaft",
  question:
      "Wie viel Prozent des globalen Handelsvolumens (im Import/Export) werden Schätzungen zufolge über den Seeweg (Containerschiffe) abgewickelt?",
  answerA: "ca. 30 Prozent",
  answerB: "ca. 55 Prozent",
  answerC: "ca. 90 Prozent",
  answerD: "99 Prozent",
  points: 50,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};

const quizContent7_11 = {
  category: "Fremdsprachen",
  question: "Welche Sprache hat weltweit die meisten Muttersprachler?",
  answerA: "Englisch",
  answerB: "Mandarin (Chinesisch)",
  answerC: "Spanisch",
  answerD: "Indisch",
  points: 10,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};

const quizContent7_12 = {
  category: "Fremdsprachen",
  question:
      "Welche Sprache der Welt besitzt das längste Alphabet (mit 73 Buchstaben)?",
  answerA: "Georgisch",
  answerB: "Russisch",
  answerC: "Khmer (Kambodscha)",
  answerD: "Thailändisch",
  points: 20,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};

const quizContent7_13 = {
  category: "Fremdsprachen",
  question:
      "Wofür ist die Sprache Xhosa (eine Amtssprache in Südafrika) besonders bekannt?",
  answerA: "Sie hat 12 grammatikalische Geschlechter",
  answerB: "Sie wird nur geflüstert",
  answerC: "Sie besteht zu 60 % aus Klicklauten",
  answerD: "Sie hat kein einziges Verb",
  points: 30,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};

const quizContent7_14 = {
  category: "Fremdsprachen",
  question:
      "Die Plansprache Esperanto wurde 1887 entwickelt, um die weltweite Kommunikation zu erleichtern. Aus welcher Sprache stammt der Großteil ihres Wortschatzes?",
  answerA: "Aus einer Mischung asiatischer Sprachen",
  answerB: "Aus germanischen Sprachen (darunter Deutsch und Englisch)",
  answerC:
      "Aus romanischen Sprachen (wie Französisch, Spanisch und Italienisch)",
  answerD: "Eine gleichmäßige Mischung aller Weltsprachen",
  points: 40,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};

const quizContent7_15 = {
  category: "Fremdsprachen",
  question:
      "Das Deutsche gehört zur germanischen Sprachfamilie. Welche der folgenden Sprachen ist überraschenderweise ebenfalls eng mit dem Deutschen verwandt?",
  answerA: "Finnisch",
  answerB: "Ungarisch",
  answerC: "Estnisch",
  answerD: "Englisch",
  points: 50,
  correctAnswer: "answerD",
  questionIsActive: false,
  questionFinished: false,
};

const quizContent7_16 = {
  category: "Japan",
  question: "Welche dieser KitKat-Geschmacksrichtungen gibt es in Japan nicht?",
  answerA: "Matcha (Grüner Tee)",
  answerB: "Erdbeere",
  answerC: "Gekochtes Ei",
  answerD: "Wasabi",
  points: 10,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};

const quizContent7_17 = {
  category: "Japan",
  question:
      "Das Tragen von Stäbchen in der Schüssel ist tabu. Was symbolisiert es, wenn man die Stäbchen senkrecht in den Reis steckt?",
  answerA: "Dass man hungrig ist",
  answerB: "Ein Ritual bei Beerdigungen",
  answerC: "Dass man nach der Rechnung verlangt",
  answerD: "Dass das Essen nicht schmeckt",
  points: 20,
  correctAnswer: "answerB",
  questionIsActive: false,
  questionFinished: false,
};

const quizContent7_18 = {
  category: "Japan",
  question:
      'Japaner sind für ihre Höflichkeit bekannt, doch beim Nudelschlürfen gilt eine ganz besondere "Etikette". Was drückt das laute Schlürfen beim Essen von Ramen oder Soba-Nudeln aus?',
  answerA: "Dass es besonders gut schmeckt und heiß ist",
  answerB: "Dass man es eilig hat",
  answerC: "Nichts, es ist unhöflich",
  answerD: "Das man noch eine Schüssel möchte",
  points: 30,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};

const quizContent7_19 = {
  category: "Japan",
  question:
      "Wenn man in Japan traditionelle Tatami-Zimmer betritt, tauscht man seine Straßenschuhe gegen Hausschuhe. Doch was zieht man an der Schwelle zu einer separaten Toilette an?",
  answerA: "Überhaupt nichts",
  answerB: "Stöckelschuhe",
  answerC: "Die gleichen Hausschuhe wie im Rest des Hauses",
  answerD: "Spezielle Toiletten-Pantoffeln",
  points: 40,
  correctAnswer: "answerD",
  questionIsActive: false,
  questionFinished: false,
};

const quizContent7_20 = {
  category: "Japan",
  question:
      "Tokio ist für seine Megacity-Ausmaße bekannt. Wie viele der berühmten Getränke- und Snack-Automaten (Jidohanbaiki) gibt es ungefähr in Japan?",
  answerA: "Etwa 50.000",
  answerB: "Knapp 100.000",
  answerC: "Rund 2,5 Millionen",
  answerD: "Knapp 300.000",
  points: 50,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};

const quizContent7_21 = {
  category: "Afrika",
  question: "Welches ist flächenmäßig das größte Land in Afrika?",
  answerA: "Kongo",
  answerB: "Elfenbeinküste",
  answerC: "Mali",
  answerD: "Algerien",
  points: 10,
  correctAnswer: "answerD",
  questionIsActive: false,
  questionFinished: false,
};

const quizContent7_22 = {
  category: "Afrika",
  question: "Ungefähr wie viele verschiedene Sprachen werden in Afrika gesprochen?",
  answerA: "über 2.000 Sprachen",
  answerB: "Über 200.000 Sprachen",
  answerC: "Über 300.000 Sprachen",
  answerD: "Über 100.000 Sprachen",
  points: 20,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};

const quizContent7_23 = {
  category: "Afrika",
  question:
      'Tierwelt: Zu den berühmten "Big Five" gehören Löwe, Leopard, Nashorn, Elefant und... welches Tier?',
  answerA: "Giraffen",
  answerB: "Affen",
  answerC: "Afrikanischer Büffel",
  answerD: "Füchse",
  points: 30,
  correctAnswer: "answerC",
  questionIsActive: false,
  questionFinished: false,
};

const quizContent7_24 = {
  category: "Afrika",
  question:
      "Wie heißt der längste Fluss des Kontinents (der auch oft als der längste der Welt bezeichnet wird)?",
  answerA: "Ligoni",
  answerB: "Hamboga",
  answerC: "Agogo",
  answerD: "Nil",
  points: 40,
  correctAnswer: "answerD",
  questionIsActive: false,
  questionFinished: false,
};

const quizContent7_25 = {
  category: "Afrika",
  question:
      "Welcher schneebedeckte Vulkan ist mit seinen 5.895 Metern der höchste Berg des afrikanischen Kontinents?",
  answerA: "Der Kilimandscharo",
  answerB: "Der Mount Speke",
  answerC: "Der Mount Meru",
  answerD: "Kamerunberg",
  points: 50,
  correctAnswer: "answerA",
  questionIsActive: false,
  questionFinished: false,
};
export const quizData = [
  {
    isActive: false,
    isSelected: false,
    quizStarted: false,
    name: "Jeopardy 1",
    madeBy: "Katja, Fredy und Oli",
    activePlayer: 1,
    content: [
      quizContent1_1,
      quizContent1_2,
      quizContent1_3,
      quizContent1_4,
      quizContent1_5,
      quizContent1_6,
      quizContent1_7,
      quizContent1_8,
      quizContent1_9,
      quizContent1_10,
      quizContent1_11,
      quizContent1_12,
      quizContent1_13,
      quizContent1_14,
      quizContent1_15,
      quizContent1_16,
      quizContent1_17,
      quizContent1_18,
      quizContent1_19,
      quizContent1_20,
      quizContent1_21,
      quizContent1_22,
      quizContent1_23,
      quizContent1_24,
      quizContent1_25,
    ],
  },
  {
    isActive: false,
    isSelected: false,
    quizStarted: false,
    name: "Jeopardy 2",
    madeBy: "Oli",
    activePlayer: 1,
    content: [
      quizContent2_1,
      quizContent2_2,
      quizContent2_3,
      quizContent2_4,
      quizContent2_5,
      quizContent2_6,
      quizContent2_7,
      quizContent2_8,
      quizContent2_9,
      quizContent2_10,
      quizContent2_11,
      quizContent2_12,
      quizContent2_13,
      quizContent2_14,
      quizContent2_15,
      quizContent2_16,
      quizContent2_17,
      quizContent2_18,
      quizContent2_19,
      quizContent2_20,
      quizContent2_21,
      quizContent2_22,
      quizContent2_23,
      quizContent2_24,
      quizContent2_25,
    ],
  },
  {
    isActive: false,
    isSelected: false,
    quizStarted: false,
    name: "Jeopardy 3",
    madeBy: "Katja",
    activePlayer: 1,
    content: [
      quizContent3_1,
      quizContent3_2,
      quizContent3_3,
      quizContent3_4,
      quizContent3_5,
      quizContent3_6,
      quizContent3_7,
      quizContent3_8,
      quizContent3_9,
      quizContent3_10,
      quizContent3_11,
      quizContent3_12,
      quizContent3_13,
      quizContent3_14,
      quizContent3_15,
      quizContent3_16,
      quizContent3_17,
      quizContent3_18,
      quizContent3_19,
      quizContent3_20,
      quizContent3_21,
      quizContent3_22,
      quizContent3_23,
      quizContent3_24,
      quizContent3_25,
    ],
  },
  {
    isActive: false,
    isSelected: false,
    quizStarted: false,
    name: "Jeopardy 4",
    madeBy: "Fredy und Oli",
    activePlayer: 1,
    content: [
      quizContent4_1,
      quizContent4_2,
      quizContent4_3,
      quizContent4_4,
      quizContent4_5,
      quizContent4_6,
      quizContent4_7,
      quizContent4_8,
      quizContent4_9,
      quizContent4_10,
      quizContent4_11,
      quizContent4_12,
      quizContent4_13,
      quizContent4_14,
      quizContent4_15,
      quizContent4_16,
      quizContent4_17,
      quizContent4_18,
      quizContent4_19,
      quizContent4_20,
      quizContent4_21,
      quizContent4_22,
      quizContent4_23,
      quizContent4_24,
      quizContent4_25,
    ],
  },
  {
    isActive: false,
    isSelected: false,
    quizStarted: false,
    name: "Jeopardy 5",
    madeBy: "Oli",
    activePlayer: 1,
    content: [
      quizContent5_1,
      quizContent5_2,
      quizContent5_3,
      quizContent5_4,
      quizContent5_5,
      quizContent5_6,
      quizContent5_7,
      quizContent5_8,
      quizContent5_9,
      quizContent5_10,
      quizContent5_11,
      quizContent5_12,
      quizContent5_13,
      quizContent5_14,
      quizContent5_15,
      quizContent5_16,
      quizContent5_17,
      quizContent5_18,
      quizContent5_19,
      quizContent5_20,
      quizContent5_21,
      quizContent5_22,
      quizContent5_23,
      quizContent5_24,
      quizContent5_25,
    ],
  },
  {
    isActive: false,
    isSelected: false,
    quizStarted: false,
    name: "Jeopardy 6",
    madeBy: "Katja",
    activePlayer: 1,
    content: [
      quizContent6_1,
      quizContent6_2,
      quizContent6_3,
      quizContent6_4,
      quizContent6_5,
      quizContent6_6,
      quizContent6_7,
      quizContent6_8,
      quizContent6_9,
      quizContent6_10,
      quizContent6_11,
      quizContent6_12,
      quizContent6_13,
      quizContent6_14,
      quizContent6_15,
      quizContent6_16,
      quizContent6_17,
      quizContent6_18,
      quizContent6_19,
      quizContent6_20,
      quizContent6_21,
      quizContent6_22,
      quizContent6_23,
      quizContent6_24,
      quizContent6_25,
    ],
  },
  {
    isActive: false,
    isSelected: false,
    quizStarted: false,
    name: "Jeopardy 7",
    madeBy: "Gizem",
    activePlayer: 1,
    content: [
      quizContent7_1,
      quizContent7_2,
      quizContent7_3,
      quizContent7_4,
      quizContent7_5,
      quizContent7_6,
      quizContent7_7,
      quizContent7_8,
      quizContent7_9,
      quizContent7_10,
      quizContent7_11,
      quizContent7_12,
      quizContent7_13,
      quizContent7_14,
      quizContent7_15,
      quizContent7_16,
      quizContent7_17,
      quizContent7_18,
      quizContent7_19,
      quizContent7_20,
      quizContent7_21,
      quizContent7_22,
      quizContent7_23,
      quizContent7_24,
      quizContent7_25,
    ],
  },
];
